// add content/page module imports here
import {WerkbonModule} from './werkbon/werkbon.module';
import {MultiSelectModule} from 'primeng/multiselect';
import { NgModule } from '@angular/core';
import { SignaturePadModule  } from 'angular2-signaturepad';
@NgModule({
  imports: [
    MultiSelectModule,
    SignaturePadModule
  ],

  exports: [
    WerkbonModule,
  ]
})

export class BuitendienstModule {  };

